import { render, staticRenderFns } from "./EditDPage.vue?vue&type=template&id=438ab236&"
import script from "./EditDPage.vue?vue&type=script&lang=js&"
export * from "./EditDPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports